module.exports = "<div class=autocomplete-location off-click=\"isActive=false\"><ng-transclude></ng-transclude><ul class=dropdown-menu ng-show=\"isOpen && isActive && searchResults.length\"><li class=item ng-repeat=\"result in searchResults\" ng-class=\"{active: $index==selectedIndex}\" ng-click=choose()(result)>{{ caption()(result) }}</li></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/recent-searches.tmpl.html
// module id = 547
// module chunks = 0